import { createSlice } from "@reduxjs/toolkit";
import instance from "../../api/api.js";

export const fectchReclamations = () => async (dispatch) => {
  try {
    const response = await instance.get("reclamations");
    console.log("REPONSERECLAMATION", response);
    const dataFilterByFlagTrue = response.data.data.filter(
      (item) => item.flag === 1
    );
    console.log("dataFilterByFlagTrue", dataFilterByFlagTrue);
    dispatch(fetchReclamationFulfilled(dataFilterByFlagTrue.length));
  } catch (error) {
    console.log();
  }
};
export const removeFlagReclamations = (payload) => async (dispatch) => {
  try {
    const response = await instance.post("/updateFlagReclamation/" + payload);
    console.log("REPONSERECLAMATION", response);
    if (response.status === true) {
      dispatch(removeItem());
    }
  } catch (error) {
    console.log();
  }
};
export const reclamationReducer = createSlice({
  name: "Reclamation",
  initialState: { reclamation_length: null },
  reducers: {
    removeItem: (state) => {
      const nouveau_length = state.reclamation_length - 1;
      return { ...state, reclamation_length: nouveau_length };
    },
    fetchReclamationFulfilled: (state, action) => {
      state.status = true;
      state.reclamation_length = action.payload; // Met à jour state.Reclamation_length avec les données de l'API
    },
  },
});

export const { handleTotalNew, fetchReclamationFulfilled, removeItem } =
  reclamationReducer.actions;
export default reclamationReducer.reducer;
